export const urls = {
    profileStatus: '/api/users/data/status'
};

export const initialState = {
    data: {},
    isFetching: false,
    isError: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_PROFILE_STATUS': {
            return {
                data: {},
                isFetching: true,
                isError: false
            };
        }
        case 'RECEIVE_PROFILE_STATUS': {
            return {
                data: action.data.data,
                isFetching: false,
                isError: false
            };
        }
        case 'ERROR_PROFILE_STATUS': {
            return {
                data: {},
                isFetching: false,
                isError: true
            };
        }
        default:
            return state;
    }
};
